import React, { useState } from "react";
import {
  Alert,
  AlertTitle,
  Collapse,
  Button,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

export default function BannerInfo({ sx }) {
  const theme = useTheme();
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(!smDown); // open on desktop, collapsed on mobile

  const short =
    "We can fully customize these styles—colors, patterns, textures, and more.";
  const long =
    "If you like any of the general styles, proceed with the steps, place your order, and then contact us with your order number and customization requests. Pricing may be adjusted for complex customizations, but simple changes like color swaps usually don’t affect the price (or only very minimally).";

  return (
    <Alert severity="info" sx={{ borderRadius: 2, ...sx }}>
      <AlertTitle>Good to know</AlertTitle>
      {short}{" "}
      {smDown ? (
        <>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {" "}
            {long}
          </Collapse>
          <Button
            size="small"
            sx={{ mt: 0.5, px: 0 }}
            onClick={() => setOpen((v) => !v)}>
            {open ? "Show less" : "Learn more"}
          </Button>
        </>
      ) : (
        long
      )}
    </Alert>
  );
}
